import React from 'react';
import { TopBar } from './components/TopBar';
import { Hero } from './components/Hero';
import { Comparativa } from './components/Comparativa';
import { Sistema } from './components/Sistema';
import { Tomos } from './components/Tomos';
import { Bonos } from './components/Bonos';
import { ValueStack } from './components/ValueStack';
import { Ofertas } from './components/Ofertas';
import { ParaQuien } from './components/ParaQuien';
import { Testimonios } from './components/Testimonios';
import { ComoFunciona } from './components/ComoFunciona';
import { Garantia } from './components/Garantia';
import { CierreFinal } from './components/CierreFinal';
import { Faq } from './components/Faq';
import { SiteFooter } from './components/SiteFooter';
import { VentasFlotantes } from './components/VentasFlotantes';
export function App() {
  return <div className="w-full bg-canvas font-sans" data-id="element-0" data-mp="28sutulzptvl7">
      <TopBar data-id="element-1" data-mp="23vkvggucm9l8" />
      <Hero data-id="element-2" data-mp="23w4fq47h1a2f" />
      <main data-id="element-3" data-mp="23u9v6r043jyv">
        <Comparativa data-id="element-4" data-mp="23utcc5hxu4bu" />
        <Sistema data-id="element-5" data-mp="23t8fuac2cbbc" />
        <Tomos data-id="element-6" data-mp="3ijxnsm94vshs" />
        <Bonos data-id="element-7" data-mp="3ikh7o8icgqyg" />
        <ValueStack data-id="element-8" data-mp="3iiwdijzxza14" />
        <Ofertas data-id="element-9" data-mp="3ijfw82xf22g7" />
        <ParaQuien data-id="element-10" data-mp="3ihv2ugmu8pjx" />
        <Testimonios data-id="element-11" data-mp="3mlj82snzz920" />
        <ComoFunciona data-id="element-12" data-mp="3ml17jjuay8oa" />
        <Garantia data-id="element-13" data-mp="3mk852v2dm5by" />
        <CierreFinal data-id="element-14" data-mp="3mjq3diwy2ywn" />
        <Faq data-id="element-15" data-mp="3mj6lu3b7icj5" />
      </main>
      <SiteFooter data-id="element-16" data-mp="3rbrc4uuwm7hx" />
      <VentasFlotantes data-id="element-17" data-mp="3rdatkosaqola" />
    </div>;
}